import axios from 'axios';
import { UNAUTHORIZED } from 'icerockdev-admin-toolkit';
import { EMPTY_TOKENS } from '~/config/auth/OAuth2AuthProvider';
import HttpStatusCode from 'http-status-typed';

function parseJwt(token: string): any {
    const base64Url = token.split('.')[1];
    const base64 = decodeURIComponent(
      atob(base64Url)
        .split('')
        .map((c) => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join('')
    );
    return JSON.parse(base64);
}

export const authRequestFn = (host: string) => async (
  code: string,
  state: string
): Promise<{
  user: {
    id?: number | undefined;
    email?: string | undefined;
    username?: string | undefined;
    role?: string | undefined;
    token?: string | undefined;
  };
  tokens: {
    access: string;
    refresh: string;
  };
  error: string;
}> => {
  try {
    const response = await axios
      .get(
        `${host}/oauth/jira/callback`,
        { params: { code, state } }
      )

    if (response.status === HttpStatusCode.UNAUTHORIZED) {
      throw new Error('Авторизация не удалась');
    }

    const body = response.data;

    if (!body.data?.accessToken) {
      throw new Error('Авторизация не удалась');
    }

    const jwt = parseJwt(body.data.accessToken);
    const user = JSON.parse(jwt.user);

    return {
      user: {
        username: user.jiraUserKey,
        token: body.data.accessToken,
      },
      tokens: {
        access: body.data.accessToken,
        refresh: body.data.refreshToken,
      },
      error: '',
    };
  } catch (e) {
    return { user: {}, tokens: { access: '', refresh: '' }, error: e.message };
  }
};

export const tokenRefreshFn = (host) => async (refreshToken) => {
  try {
    const result = await axios
      .post(`${host}/auth/refresh`, { refreshToken });

    if (!result?.data?.data?.accessToken || !result?.data?.data?.refreshToken) {
      throw new Error(UNAUTHORIZED);
    }
    return {
      access: result.data.data.accessToken,
      refresh: result.data.data.refreshToken,
    };
  } catch (e) {
    return EMPTY_TOKENS;
  }
};
